export default {
  event: {
    eventType: {
      online: 'Online',
      inPerson: 'In person',
      call: 'Call',
    },
    eventRole: {
      host: 'Host',
      guest: 'Guest',
    },
  },
};
